import { z } from 'zod'

import { StructuredDataType } from '../../dtos/structured-data'

export const makeTypeLiteral = <T extends StructuredDataType>(type: T) => z.literal(type)

export const validateUniqueLabels = {
  fn: (data: { label: string }[]) => {
    const labels = data.map((item) => item.label.toLocaleLowerCase())
    return labels.length === new Set(labels).size
  },
  error: {
    message: 'Labels must be unique',
    path: ['label'],
  },
}

export const validateUniqueIds = {
  fn: (data: { id: string }[]) => {
    const ids = data.map((item) => item.id)
    return ids.length === new Set(ids).size
  },
  error: {
    message: 'Ids must be unique',
    path: ['id'],
  },
}
